module.exports = __webpack_public_path__ + "img/depmap_svg_V83.4d330531.svg";